import { DatePickerDate, PopoverOrigin } from '@lyearn/ui';
import { RelativeDateFilterOperatorEnum, RelativeDateFilterUnitEnum } from '@/types/schema';

import { DateFilterPosition } from './types';

export enum DateView {
  START_DATE = 'START_DATE',
  END_DATE = 'END_DATE',
}

export enum DateFilterListItemKey {
  Last7Days = 'LAST_7_DAYS',
  Last30Days = 'LAST_30_DAYS',
  Last3Months = 'LAST_3_MONTHS',
  Last6Months = 'LAST_6_MONTHS',
  LastYear = 'LAST_YEAR',
  Today = 'TODAY',
  Tomorrow = 'TOMORROW',
  Yesterday = 'YESTERDAY',
  ThisWeek = 'THIS_WEEK',
  LastWeek = 'LAST_WEEK',
  NextWeek = 'NEXT_WEEK',
  ThisMonth = 'THIS_MONTH',
  LastMonth = 'LAST_MONTH',
  Next1DayFromNow = 'NEXT_1_DAY_FROM_NOW',
  Next2DaysFromNow = 'NEXT_2_DAYS_FROM_NOW',
  Next7DaysFromNow = 'NEXT_7_DAYS_FROM_NOW',
  Next30DaysFromNow = 'NEXT_30_DAYS_FROM_NOW',
  NextYear = 'NEXT_YEAR',
  Custom = 'CUSTOM',
  Overdue = 'OVERDUE',
  ThisYear = 'THIS_YEAR',
}

interface DateFilterValue {
  relative: {
    value: number;
    operator: RelativeDateFilterOperatorEnum;
    unit: RelativeDateFilterUnitEnum;
  };
}

export interface DateFilterListItem {
  label: string;
  value?: number | DateFilterValue;
  key: DateFilterListItemKey;
  Icon?: JSX.Element;
}

export interface DateSelectorProps {
  options: DateFilterListItem[];
  selectedOption?: DateFilterListItem;
  startTime?: Date;
  endTime?: Date;
  onDone: (
    startTime: DatePickerDate,
    endTime: DatePickerDate,
    listItem?: DateFilterListItem,
  ) => void;
  onCancel: () => void;
  position?: DateFilterPosition;
  open: boolean;
  children: React.ReactNode;
}

export interface DateListProps {
  list?: DateFilterListItem[];
  selectedItem?: DateFilterListItem;
  onClick: (item: DateFilterListItem) => void;
  //mobile-only
  selectedDateFilterItem?: DateFilterListItem;
}

export const CustomFilterListItem: DateFilterListItem[] = [
  {
    key: DateFilterListItemKey.Custom,
    label: 'Common:PickDateRange',
  },
];

export const DateFilterListItems: DateFilterListItem[] = [
  {
    key: DateFilterListItemKey.Last7Days,
    label: 'Common:Last7Days',
    value: 7,
  },
  {
    key: DateFilterListItemKey.Last30Days,
    label: 'Common:Last30Days',
    value: 30,
  },
  {
    key: DateFilterListItemKey.Last3Months,
    label: 'Common:Last3Months',
    value: 3,
  },
  {
    key: DateFilterListItemKey.LastYear,
    label: 'Common:LastYear',
    value: 12,
  },
  ...CustomFilterListItem,
];

export const ANCHOR_ORIGIN_RIGHT: PopoverOrigin = {
  vertical: 'bottom',
  horizontal: 'right',
};

export const TRANSFORM_ORIGIN_RIGHT: PopoverOrigin = {
  vertical: 'top',
  horizontal: 'right',
};

export const ANCHOR_ORIGIN_LEFT: PopoverOrigin = {
  vertical: 'bottom',
  horizontal: 'left',
};

export const TRANSFORM_ORIGIN_LEFT: PopoverOrigin = {
  vertical: 'top',
  horizontal: 'left',
};

export const POPOVER_CLASSES = {
  paper: 'rounded-8 mt-8 shadow-01 pb-0',
};

export const BUTTON_LABEL_CLASSES = {
  root: 'ps-16 pt-12 pb-12 justify-start',
  label: 'body-short-01',
};

export const FUTURE_DATE_FILTER_ITEMS: DateFilterListItem[] = [
  { key: DateFilterListItemKey.Today, label: 'Common:Today' },
  { key: DateFilterListItemKey.Tomorrow, label: 'Common:Tomorrow' },
  { key: DateFilterListItemKey.ThisWeek, label: 'Common:ThisWeek' },
  { key: DateFilterListItemKey.NextWeek, label: 'Common:NextWeek' },
  { key: DateFilterListItemKey.ThisMonth, label: 'Common:ThisMonth' },
  { key: DateFilterListItemKey.Overdue, label: 'Common:Overdue' },
  { key: DateFilterListItemKey.Custom, label: 'Common:PickDateRange' },
];
